import { animated } from '#app/components/Primitives/Animated.js';
import { type ShapeProps } from '#app/components/Shapes/types.js';
import { SvgGradient } from '#app/components/SvgGradient/SvgGradient.js';
import { useLinearGradientDetails } from '#app/hooks/useLinearGradientDetails.js';

const SquareRounded = ({ gradient, type, ...props }: ShapeProps) => {
  const { id, url } = useLinearGradientDetails();

  return (
    <animated.svg
      viewBox="0 0 192 192"
      {...props}
    >
      <SvgGradient
        id={id}
        {...gradient}
      />
      <path
        d="M97.514 191.282c-52.346 0-94.764-42.214-94.764-94.266C2.75 44.964 45.168 2.75 97.514 2.75h94.261v188.532h-94.26z"
        fill={type === 'fill' ? url : 'none'}
        stroke={type === 'stroke' ? url : 'none'}
        strokeWidth={4}
      />
    </animated.svg>
  );
};

export default SquareRounded;
